import React from 'react';

/**
 * Modal genérico para mostrar notificaciones de éxito o error.
 * @param {object} props
 * @param {boolean} props.show - Si el modal debe estar visible.
 * @param {() => void} props.onClose - Función para cerrar el modal.
 * @param {string} props.message - El mensaje a mostrar.
 * @param {'success' | 'error'} props.type - El tipo de notificación (define el estilo).
 */
const ModalNotificacion = ({ show, onClose, message, type = 'success' }) => {
  if (!show) return null;

  const isSuccess = type === 'success';
  const bgColor = isSuccess ? 'bg-green-100 border-green-400 text-green-700' : 'bg-red-100 border-red-400 text-red-700';
  const icon = isSuccess ? (
    <svg className="w-6 h-6 mr-3 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
  ) : (
    <svg className="w-6 h-6 mr-3 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
  );

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`bg-white rounded-xl shadow-2xl max-w-sm w-full border-t-4 ${isSuccess ? 'border-green-500' : 'border-red-500'}`}>
        <div className="p-6">
          <div className="flex items-center">
            {icon}
            <h3 className={`text-lg font-semibold ${isSuccess ? 'text-green-800' : 'text-red-800'}`}>
              {isSuccess ? '¡Éxito en la Operación!' : 'Error'}
            </h3>
          </div>
          <p className="mt-4 text-gray-700 text-sm">
            {message}
          </p>
          <div className="mt-6 flex justify-end">
            <button
              onClick={onClose}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg shadow-md transition-colors text-sm"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalNotificacion;